// extracted by mini-css-extract-plugin
module.exports = {"contactItem":"contact-item_contactItem__1U3Cj"};